import React from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, Button } from "@nextui-org/react";

function AddModal({ isOpen, onClose, deleteName, query, unit, deleteItem }) {
  return (
    <Modal size={"xs"} isOpen={isOpen} onClose={onClose} placement="center">
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 justify-center">
              {deleteName === "warranty"
                ? `Do you want to delete " ${query} ${unit}"`
                : `Do you want to delete "${query}"`}
            </ModalHeader>
            <ModalBody>
              <div className="grid grid-cols-2 gap-2 pb-3">
                <Button
                  className="border-2 border-orange-500 text-orange-500 bg-transparent hover:bg-orange-500 hover:text-white hover:border-none"
                  onPress={onClose}
                >
                  Cancel
                </Button>
                <Button
                  className="border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500 hover:text-white hover:border-none"
                  onClick={deleteItem}
                >
                  Delete
                </Button>
              </div>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}

export default AddModal;
